export default "__VITE_ASSET__ZJECMHf4__"